// Project classification: Category → Subcategory.
//
// Both come from the database (ProjectTypeConfig), and from nowhere else.
// Settings → Project Types is the only place they are defined or changed.
//
// This file used to carry a second, hardcoded list that was merged on top of
// the database one. The result was a picker showing the union of two sources
// while Settings could only see and edit one of them, so the two drifted:
// "Mobile App" (from the code) sat in the dropdown beside "Mobile App
// Development" (from the database) as two names for the same service, with
// live projects filed under each, and no screen that could reconcile them.
//
// The code list has been migrated into the database
// (CRE-BE/src/scripts/consolidateProjectCategories.js) and removed. What the
// picker offers is now exactly what Settings shows.

export interface CategoryDef {
  name: string;
  subcategories: string[];
}

/**
 * Category names for a picker, from the configured project types.
 *
 * Returns what it is given. The signature is kept so every call site stays a
 * single, obvious place that asks for "the configured categories" — and so
 * nothing can quietly reintroduce a local default.
 */
export const mergeCategoryNames = (dbNames: string[] = []): string[] => [...dbNames];

/**
 * Subcategories for a category, from that type's configured sub-types.
 *
 * An empty list means the category has no sub-types configured, which is a
 * real answer: the picker says so rather than offering options nobody set up.
 */
export const subcategoriesFor = (_categoryName: string, dbSubTypes: string[] = []): string[] => [
  ...dbSubTypes,
];
